export default __webpack_public_path__ + "static/media/Weather_06.f5579683.png";